/**
 * @generated SignedSource<<8a61addc7849ce7b67de5cbb11ba2406>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateScheduleShiftPayload",
            "kind": "LinkedField",
            "name": "updateScheduleShift",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleShift",
                    "kind": "LinkedField",
                    "name": "shiftEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleShift",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleShiftDescriptionMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleShiftDescriptionMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "7a128559f92c8a05e119fc014df1475c",
            "id": null,
            "metadata": {},
            "name": "EditScheduleShiftDescriptionMutation",
            "operationKind": "mutation",
            "text": "mutation EditScheduleShiftDescriptionMutation(\n  $model: UpdateScheduleShiftRequestInput!\n) {\n  updateScheduleShift(model: $model) {\n    shiftEdge {\n      node {\n        id\n        description\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "2d22ed104d0d81cf06a25bf506e2246c";
export default node;
